import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar';
import FetchUserDetails from '../../components/UserDetails/FetchUserDetails';
import SurveyDashboard from './SurveyDashboard';

const SurveyDashboardHome = () => {
  const [isGetUserDetailsFunctionExecuted, setIsGetUserDetailsFunctionExecuted] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    const savedState = sessionStorage.getItem('isSidebarCollapsed');
    return savedState ? JSON.parse(savedState) : false;
  });

  useEffect(() => {
    sessionStorage.setItem('isSidebarCollapsed', JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  useEffect(() => {
    const getUserDetails = async () => {
      try {
        if (
          sessionStorage.getItem('user_name') &&
          sessionStorage.getItem('user_emailId') &&
          sessionStorage.getItem('user_id')
        ) {
          setIsGetUserDetailsFunctionExecuted(true);
          return;
        }

        const userFetched = await FetchUserDetails();
        if (!userFetched) {
          console.error('Failed to fetch user details.');
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
      } finally {
        setIsGetUserDetailsFunctionExecuted(true);
      }
    };

    getUserDetails();
  }, []);

  if (!isGetUserDetailsFunctionExecuted) {
    return null;
  }

  return (
    <div id="home1">
      <Sidebar onToggleSidebar={handleToggleSidebar} isCollapsed={isSidebarCollapsed} />
      <div id="home2" className={`survey-home-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <SurveyDashboard />
      </div>
    </div>
  );
};

export default SurveyDashboardHome;


